export type ToggleContentEventDetail = {
    action: "open" | "close";
    identifier: string | null;
};

export class ToggleContentEvent extends CustomEvent<ToggleContentEventDetail> {
    public static readonly KEY = "toggle-content";

    public constructor(
        eventInitDict: CustomEventInit<ToggleContentEventDetail>,
    ) {
        super(ToggleContentEvent.KEY, eventInitDict);
    }
}
